import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Desube, simple de la tero, blindigas okulojn hela Suno. 
      Kio okazis? 
      Ĉu la Suno subiris al la Tero?
    </p>
    
    <p class="mb-3">
      Ne, tio ne estas Suno; estas nur eta Splito, malgranda peceto da vitro. 
      Iuj opinias, ke la printempo tute ne koncernas lin, ke ne estas lia afero printempa impeto.
    </p>
    
    <p class="mb-3">
      Sed ankaŭ li ĝojas la reviviĝon.
    </p>
    
    <p class="mb-3">
      Kaj tiu ĝojo faras lin simila al al Suno.
    </p>
    `
  )
}

const itemName = {
  esp: 'La suno'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;